module.exports = __webpack_public_path__ + "img/arrow_right_white.c244d127.svg";